import { Box, Tooltip, Typography, makeStyles } from "@material-ui/core";
import { Color } from "../../../../theme";

type Props = {
  selectedAmount: number;
  text?: string;
};

export const SelectBadge = ({ selectedAmount, text }: Props) => {
  const classes = useStyles();
  return (
    selectedAmount > 0 &&
    (selectedAmount === 1 && text ? (
      <Tooltip title={text} placement="top-end">
        <Box className={classes.textBadge}>
          <Typography variant="subtitle1" className={classes.textBadgeText}>
            {text}
          </Typography>
        </Box>
      </Tooltip>
    ) : (
      <Box className={classes.numberBadge}>
        <Typography variant="body1">{selectedAmount}</Typography>
      </Box>
    ))
  );
};

const useStyles = makeStyles(() => ({
  numberBadge: {
    position: "absolute",
    left: "calc(100% - 0.75rem)",
    bottom: "calc(100% - 0.75rem)",
    borderRadius: "200rem",
    backgroundColor: Color.DoveBlue,
    border: `1px solid ${Color.DoveBlue}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "1.5rem",
    width: "1.5rem",
    color: Color.White,
    zIndex: 10
  },
  textBadge: {
    position: "absolute",
    left: "100%",
    transform: "translateX(calc(-100% + 0.75rem))",
    bottom: "calc(100% - 0.75rem)",
    borderRadius: "200rem",
    backgroundColor: Color.DoveBlue,
    border: `1px solid ${Color.DoveBlue}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "1.5rem",
    maxWidth: "90%",
    color: Color.White,
    zIndex: 10
  },
  textBadgeText: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    padding: "0 4px",
    overflow: "hidden",
    color: Color.White
  }
}));
